import app from 'app';
import { workPool } from '@wochitnpm/helpers';

/**
 * @namespace workPool.job.snapBeats
 */
export default workPool.define(
  'snapBeats',
  {
    initialize() {
      const { asset } = this.options;
      const BGMusicSourceId = asset.metadata.assetUUID;
      this.firebaseKey = `BG_MUSIC-${BGMusicSourceId}`;
      this.startTime = ~~(Date.now() / 1000);
    },

    run() {
      const thenCreate = new _.ColdPromise();
      const { asset, checkIfExists } = this.options;

      if (checkIfExists) {
        app.api.beats.check(asset).then(
          (res) => {
            if ('DONE' === res.status) {
              this.onDone(res);
            } else if ('FAILED' === res.status) {
              thenCreate.resolve(); // retry
            } else {
              this.waitTillDone(asset);
            }
          },
          (err) => {
            if (err.errorCode === 404) {
              app.api.beats
                .create(asset)
                .then(() => {
                  this.waitTillDone(asset);
                })
                .catch((e) => {
                  this.onError(
                    `failed to create beats for ${asset.metadata.assetUUID}`
                  );
                });
            } else {
              // here i catch the error - that i can use
              thenCreate.resolve(); // retry
            }
          }
        );
      } else {
        thenCreate.resolve();
      }

      thenCreate.then(() => {
        this.waitTillDone(asset);
      });
    },

    waitTillDone(asset) {
      this.$emit({ status: 'PROGRESS' });
      this.listenToFirebase().then(
        () => {
          app.api.beats.check(asset).then(
            (res) => {
              if (res.status === 'DONE') {
                this.onDone(res);
              } else {
                this.onError('readiness status out of sync');
              }
            },
            (err) => {
              this.onError(
                `failed to check after firebase done ${JSON.stringify(err)}`
              );
            }
          );
        },
        () => {
          this.onError('firebase reported failure');
        }
      );
    },

    async onDone(res) {
      const data = await fetch(app.prependHttp(res.cdnUrl))
        .then((res) => {
          return res.json();
        })
        .catch(() => {
          this.abort();
        });

      if (data?.beats?.length) {
        const { asset } = this.options;
        this.$emit({
          status: 'DONE',
          duration: asset.metadata.duration,
          ...data,
        });
        this.finish();
      }
    },

    onError(err) {
      app.doctorController.report(`snapBeats: ${err}`);
      this.abort();
    },

    listenToFirebase() {
      const promise = new _.ColdPromise();

      app.api.realTime.listenOn({
        path: `/beatDetections/${this.firebaseKey}`,
        callback: ({ val }) => {
          const timeStamp = val.timestamp;
          if (timeStamp - this.startTime < 0) {
            // ignore old message
          } else if (val.data === 'DONE') {
            promise.resolve();
          } else if (val.data === 'FAILED') {
            promise.reject();
          }
        },
        errorCallback: promise.reject,
      });

      promise.finally(() => {
        this.stopListenToFirebase();
      });

      return promise;
    },

    stopListenToFirebase() {
      app.api.realTime.cancelListen(`/beatDetections/${this.firebaseKey}`);
    },
  },
  {
    isRunning(asset) {
      return workPool.has({
        type: this.type,
        context: (jc) => jc.assetUUID === asset.metadata.assetUUID,
      });
    },

    execute({ asset, checkIfExists }) {
      const isRunning = this.isRunning(asset);

      if (!isRunning) {
        workPool.add(new this({ asset, checkIfExists }));
      }
    },
  }
);
